import { api } from '~/services/api'
import { $userInfo } from '~/store/user-info'
import type { Activity, ClaimableReward } from '~/types/game-pass'
import type { PutRewardResponse } from '~/types/reward'

export function getActivity(id: number, userId: number) {
  return api.service
    .get(`gamepass/users/${userId}/activities/${id}`)
    .json<Activity>()
}

export function claimReward(activityId: number, stepId: number) {
  const userId = $userInfo.get()?.user_id
  return api.service
    .put(
      `gamepass/users/${userId}/activities/${activityId}/progression-steps/${stepId}/claim`,
    )
    .json<PutRewardResponse>()
}

export function getClaimableRewards(activityId: number) {
  const userId = $userInfo.get()?.user_id
  return api.service
    .get(`gamepass/users/${userId}/activities/${activityId}/rewards`)
    .json<{ rewards: ClaimableReward[] }>()
}
